// @flow
import { createSelector } from 'reselect'
import { path } from 'ramda'

import type { BrandConfig, CookieConsentOptions } from '@alphaott/common-types'

import { getBrand } from './main'

export const getCookieConsentOptions = createSelector(
  [getBrand],
  (brand: BrandConfig): ?CookieConsentOptions => path(['options', 'cookieConsent'], brand),
)

export const isCookieConsentEnabled = createSelector(
  [getCookieConsentOptions],
  (opts: ?CookieConsentOptions): boolean => Boolean(opts && opts.enabled),
)
